<template>
  <section class="py-12 bg-white px-6 max-w-7xl mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      <Card
        v-for="card in cards"
        :key="card.title"
        :title="card.title"
        :description="card.description"
        :link="card.link"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import Card from "@/components/ui/Card.vue";
defineProps<{
  cards: { title: string; description: string; link: string }[];
}>();
</script>
